import { useState } from "react";
import { getCurrentEnvironmentName } from "Selectors/app";
import { useSelector } from "react-redux";
import { useETLData, useReviewReportingData } from "../../Api/services/etl";

export const useETLPage = () => {
	const [searchID, setSearchId] = useState("");
	const environment = useSelector(getCurrentEnvironmentName);

	// ELT Data
	const { data: etlData } = useETLData(environment);

	// reporting data
	const {
		data: reportingData,
		isLoading: isLoadingReport,
		refetch: getReportById,
		isError: isGetReportError,
	} = useReviewReportingData(environment, searchID);

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			getReportById();
		}
	};

	return {
		searchID,
		etlData,
		reportingData,
		isLoadingReport,
		isGetReportError,
		handleSearchChange: setSearchId,
		handleKeyDown,
		handleSearch: getReportById,
	};
};
